import React from 'react';
import {
  TdsHeader,
  TdsHeaderTitle,
  TdsHeaderLauncher,
  TdsHeaderLauncherListTitle,
  TdsHeaderLauncherList,
  TdsHeaderLauncherListItem,
  TdsHeaderDropdownList,
  TdsHeaderBrandSymbol,
  TdsHeaderDropdown,
} from '@scania/tegel-react';
import { defineCustomElements } from '@scania/tegel/loader';
import { useAuth } from '../auth/useAuth';

defineCustomElements();

const Header: React.FC = () => {
  const { account, logout } = useAuth();

  return (
    <TdsHeader>
      <nav>
        <ul className="tds-header-component-list">
          <TdsHeaderTitle role="listitem">
            Eagle Maps
          </TdsHeaderTitle>
          <li className="tds-header-middle-spacer" />

          {/* Menu Launcher */}
          <TdsHeaderLauncher slot="end" tdsAriaLabel="Launcher menu" role="listitem">
            <TdsHeaderLauncherListTitle>
              <h3 className="tds-header-launcher-list-title" id="tds-header-launcher-apps">
                Menu
              </h3>
            </TdsHeaderLauncherListTitle>
            <TdsHeaderLauncherList>
              <TdsHeaderDropdownList role="list" aria-labelledby="tds-header-launcher-apps" size="lg">
                <TdsHeaderLauncherListItem role="listitem">
                  <a href="https://sas2.scania.com">Eagle</a>
                </TdsHeaderLauncherListItem>
                <TdsHeaderLauncherListItem role="listitem">
                  <a href="https://sisupdate.scania.com/">SIS</a>
                </TdsHeaderLauncherListItem>
                <TdsHeaderLauncherListItem role="listitem">
                  <a href="https://tegel.scania.com">HELP</a>
                </TdsHeaderLauncherListItem>
              </TdsHeaderDropdownList>
            </TdsHeaderLauncherList>
          </TdsHeaderLauncher>

          {/* User profile dropdown, using Tegel design */}
          <TdsHeaderDropdown
            slot="end"
            label={account?.name || account?.username || "User"}
            no-dropdown-icon={false}
            style={{ marginLeft: 16 }}
          >
            <TdsHeaderDropdownList>
              <TdsHeaderLauncherListItem role="listitem">
                <button
                  onClick={logout}
                  style={{
                    background: "none",
                    border: "none",
                    color: "#002663",
                    fontWeight: 500,
                    cursor: "pointer",
                    padding: 0,
                  }}
                >
                  Log out
                </button>
              </TdsHeaderLauncherListItem>
            </TdsHeaderDropdownList>
          </TdsHeaderDropdown>

          <TdsHeaderBrandSymbol slot="end" role="listitem">
            <a href="https://scania.com" aria-label="Scania website"></a>
          </TdsHeaderBrandSymbol>
        </ul>
      </nav>
      <style>
      {`
      .tds-header-dropdown-list {
        max-height: 350px !important;
        overflow-y: auto !important;
      }
      `}
      </style>
    </TdsHeader>
  );
};

export default Header;
